<template>
	<span v-if="video.isLoaded" id="video-timestamp">{{ video.currentTime }} / {{ video.duration }}</span>
</template>
<script>
import {mapState} from "vuex";

export default {
	computed: {
		...mapState("UI", ["video"]),
	},
};
</script>
<style lang="scss">
#video-timestamp {
	position: absolute;
	bottom: -25px;
	font-size: 12px;
	left: 50%;
	transform: translateX(-50%);
}
</style>
